import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Big, hard-to-miss banner shown above checkout flows. The buyer's Stripe
 * email is what we use to credit Sapphires in-game — if it doesn't match
 * their Google Sign-In email the credit cannot land automatically.
 */
const EmailMatchWarning = () => (
  <div
    className="mb-6 rounded-xl border-2 border-[#f5b400] bg-gradient-to-br from-[#f5b400]/15 via-[#1a1410]/70 to-black/70 p-5 md:p-6 shadow-[0_0_30px_-10px_rgba(245,180,0,0.55)]"
    role="alert"
    data-testid="email-match-warning"
  >
    <div className="flex gap-4 items-start">
      <AlertTriangle
        className="text-[#f5b400] shrink-0 mt-0.5 drop-shadow-[0_0_8px_rgba(245,180,0,0.6)]"
        size={28}
      />
      <div>
        <h3 className="font-heading text-[#f5b400] text-lg md:text-xl uppercase tracking-wide">
          Use the same email!
        </h3>
        <p className="text-white/90 text-sm md:text-[15px] mt-1.5 leading-relaxed">
          Please pay using <b>exactly the same email address</b> that you use to log
          into the game (your Google Sign-In email).
        </p>
        <p className="text-white/70 text-sm mt-2 leading-relaxed">
          If the emails don&apos;t match, your Sapphires <b>cannot be credited
          automatically</b>. We will need to apply them manually, which can take up
          to <b>48 hours</b>.
        </p>
      </div>
    </div>
  </div>
);

export default EmailMatchWarning;
